import MobileSignPage from "@/views/signature/MobileSignPage.vue";

export default [
    {
        path: "/m/sign",
        name: "mobileSign",
        component: MobileSignPage,
        meta: { requiresAuth: false }
    }
];
